import { useEffect } from "react"

export default function AlertMessage({ message, type = "success", onClose }) {

    // auto close after 3 seconds
    useEffect(() => {

        const timer = setTimeout(() => {
            onClose && onClose()
        }, 3000)

        return () => clearTimeout(timer)

    }, [onClose])

    return (

        <div className={` z-100 fixed top-5 left-1/2 -translate-x-1/2 px-6 py-3 rounded shadow-lg text-white
            ${type === "success" ? "bg-green-500" : "bg-red-500"}`}>

            {message}

        </div>

    )

}